<template>
  <!-- LEFT COLUMN CONTENT PAGE -->
  <div
    class="hidden lg:block w-full bg-grey-lighter rounded-sm font-semibold leading-normal tracking-wide uppercase"
  >
    <h3 class="py-4 px-4 font-semibold text-base">
      <slot name="title" />
    </h3>
    <ul class="list-reset">
      <slot />
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
li {
  &:hover {
    @apply bg-grey;
  }
  a {
    @apply block py-3 px-4 font-semibold text-xs text-grey-darker;
  }
}
</style>
